import dataUbiquity from "../data/ubiquity.json";

function getUbiquitySupplyChain() {

  const dataUniqueProcessors = dataUbiquity.map((item) => { 
    return { 
      type: "processor", 
      ...item,
      importer_slugs: item.importers.map(importer => importer.slug),
      flags_ubiquity: item.flags,
      flags: item.b2p_style_flags,
    }})
    .filter((obj, index, self) => {
      return index === self.findIndex((t) => (
        t.slug.trim() === obj.slug.trim()
      ));
    })
    .sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    });

  
  const dataUniqueImporters = dataUbiquity.reduce((acc, item) => acc.concat(item.importers), [])
    .map(item => { 
      return { 
        type: "importer",
        ...item,
      }
    })
    .filter((obj, index, self) => {
      return index === self.findIndex((t) => (
        t.slug.trim() === obj.slug.trim()
      ));
    })
    .sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    });
  
  
  const importerGetAllLinkedFlags = (importer) => {
    const flags = [];
    const processors = dataUniqueProcessors.filter(processor => processor.importer_slugs.includes(importer.slug));
    /*
    const vessels = dataVessels.filter(vessel => vessel.raw.processors_list.filter(processor => processors.map(processor => processor.slug).includes(processor)).length > 0);
    flags.vessel_flags = vessels.reduce((acc, vessel) => [...acc, ...vessel.flags], [])
      .sort(function (a, b) {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        } else {
          return 0;
        }
      })
      .filter((obj, index, self) => {
        return index === self.findIndex((t) => (
          t.trim() === obj.trim()
        ));
      });
      */
  
    flags.processor_flags = processors.reduce((acc, processor) => [...acc, ...processor?.flags], []).sort(function (a, b) {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    })
    .filter((obj, index, self) => {
      return index === self.findIndex((t) => (
        t.trim() === obj.trim()
      ));
    });
    return flags;
  }
  
  const dataImportersWithFlags = dataUniqueImporters.map((importer, index) => {
    const allLinkedFlags = importerGetAllLinkedFlags(importer);
    importer.processor_flags = allLinkedFlags?.processor_flags || [];
    //importer.vessel_flags = allLinkedFlags?.vessel_flags || [];
    
    return importer;
  });
  
  const dataUniqueBuyers = dataUbiquity.reduce((acc, item) => acc.concat(item.importers) , [])
    .reduce((acc, item) => acc.concat(item.buyers), [])
    .map(item => { 
      return { 
        type: "buyer",
        ...item,
      }
    })
    .filter((obj, index, self) => {
      return index === self.findIndex((t) => (
        t.slug.trim() === obj.slug.trim()
      ));
    })
    .sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    })
    .map((buyer, index) => {
      const processors = dataUniqueProcessors.filter(processor => processor?.importers.filter(importer => importer.buyers.find(buyerItem => buyerItem.slug === buyer.slug)).length > 0);
        
      buyer.processors = processors.map(processor => processor.slug);
      if ( buyer.slug === "les-aliments-mm-canada" ) {
        //console.log("buyer", buyer)
      }
      return buyer;
    });
  
  
    const buyerGetAllLinkedFlags = (buyer) => {
      const flags = [];
      const importersWithFlags = dataImportersWithFlags;
      const vessel_flags = [];
      const processor_flags = [];
      //const importers = importersWithFlags.filter(item => item.buyers.find(buyerItem => buyerItem.slug === buyer.slug)).map((importer, index) => {
    
        //const processors = dataUniqueProcessors.filter(processor => processor.importer_slugs.includes(importer.slug) && buyer.processors.includes(processor.slug));

        const processors = dataUniqueProcessors.filter(processor => buyer.processors.includes(processor.slug));
        /*
        processors.map(processor => {
          const vesselFlags = dataVessels.filter(vessel => vessel.raw.processors_list.includes(processor.slug)).reduce((acc, vessel) => [...acc, ...vessel.flags], []);
          vessel_flags.push(...vesselFlags);
        });
        */
    
        const processorFlags = processors.reduce((acc, processor) => [...acc, ...processor?.flags], []);
        processor_flags.push(...processorFlags);
    
        //return importer;
    
      //});
      /*flags.vessel_flags = vessel_flags.sort(function (a, b) {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        } else {
          return 0;
        }
      })
      .filter((obj, index, self) => {
        return index === self.findIndex((t) => (
          t.trim() === obj.trim()
        ));
      });*/
      flags.processor_flags = processor_flags.sort(function (a, b) {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        } else {
          return 0;
        }
      })
      .filter((obj, index, self) => {
        return index === self.findIndex((t) => (
          t.trim() === obj.trim()
        ));
      });
    
      return flags;
    }
    
    const dataBuyersWithFlags = dataUniqueBuyers.map((buyer) => {
      const allLinkedFlags = buyerGetAllLinkedFlags(buyer);
      buyer.processor_flags = allLinkedFlags?.processor_flags || [];
      //buyer.vessel_flags = allLinkedFlags?.vessel_flags || [];
      return buyer;
    });
    
    
  
  const TOOL_CATEGORIES = [
    {
      name: "Processors",
      slug: "processors",
      description: "Seafood processing plants in China",
      items: dataUniqueProcessors,
    },
    {
      name: "Importers",
      slug: "importers",
      description: "Companies receiving seafood from specific processing plants in China",
      items: dataImportersWithFlags,
    },
    {
      name: "Buyers",
      slug: "buyers",
      description: "Grocery Stores, Food Service Companies, Federal Agencies, and Restaurants",
      items: dataBuyersWithFlags,
    }
  ];
  
  const ubiquityFullIndexItemsCombined = TOOL_CATEGORIES.map((category, index) => {
    return category.items.map((item, index) => {
      return {
        ...item,
      }
    });
  }).flat().sort(function (a, b) {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    else {
      return 0;
    }
  });
  
    return ubiquityFullIndexItemsCombined;
  }

export default getUbiquitySupplyChain;